/**
* 
* ## match map between beds and add ons
* 
* ```json
* {
*  [add ons variant id ]:{
*     pIds:[bed ids],  //
*     num:1,           // how many beds that should be matched.
*  }
* }
* ```
* 
*/

window.initAddonsWidget = () => {
    const addonsMapBeds = document.querySelector('.add-on-map-beds');
    if (addonsMapBeds) {

        const matchMap = JSON.parse(addonsMapBeds.textContent.trim())
        const bedIds = Array.from(new Set(Object.values(matchMap).map(item => item.pIds).flat(2)))
        const bedVariantIds = Array.from(new Set(Object.values(matchMap).map(item => item.vIds).flat(2).filter(item => item)))

        /**
         *  display not match add ons tips
         * @param id : add ons variant ids
         */
        const handleLineItemAddonTips = (ids) => {
            if (!!ids.length) {
                ids.forEach(vid => {
                    let lineItemEls = document.querySelectorAll(
                      `.cart-area.cart-area-items [data-v-id="${vid}"] .ajaxcart__row`
                    );
                    Array.from(lineItemEls).forEach(el => {
                        let tipsEl = el.querySelector('.add-on-tips-inline')
                        if (!tipsEl) {
                            tipsEl = document.createElement('div')
                            tipsEl.className = 'add-on-tips-inline'
                            el.appendChild(tipsEl)
                        }
                        tipsEl.innerHTML = `<span><b><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.80994 1.14319C11.4917 1.14336 14.476 4.12839 14.476 7.81018C14.4758 11.4918 11.4916 14.476 7.80994 14.4762C4.12815 14.4762 1.14312 11.4919 1.14294 7.81018C1.14294 4.12828 4.12804 1.14319 7.80994 1.14319ZM7.80408 7.14319C7.43601 7.14319 7.13729 7.44216 7.13708 7.81018V10.4762C7.13708 10.8444 7.43589 11.1432 7.80408 11.1432C8.17211 11.143 8.47107 10.8443 8.47107 10.4762V7.81018C8.47087 7.44228 8.17199 7.14337 7.80408 7.14319ZM7.80408 4.85706C7.43601 4.85706 7.13729 5.15603 7.13708 5.52405C7.13708 5.89224 7.43589 6.19104 7.80408 6.19104H7.80994C8.1779 6.19078 8.47693 5.89208 8.47693 5.52405C8.47673 5.15619 8.17778 4.85732 7.80994 4.85706H7.80408Z" fill="#9A4A27"/>
</svg></b>This add-on is not compatible with the selected product.</span>`;
                    })
                })

            };

        }
        const addonTips = (res) => {
            const el = document.querySelector('.add-on-tips');
            const cautionEl = document.querySelector('.add-on-tips');
            if (res.isMatchBed) {
                cautionEl.style.display = 'none'
            } else {
                cautionEl.style.display = 'flex'
                el.style.display = 'block'
                handleLineItemAddonTips(Object.keys(res.addons ?? {}))
                Popper.createPopper(el.querySelector('span'))//, this.$dropdown[0], options)
            }
        }
        /**
         * Handle Shipping Fee
         */
        const shippingFeeFn = (total, cartTotal) => {
            let freeShippingEl = document.querySelector('.vego-prompt-banner  div.free-shipping')
            //if (!document.querySelector('.free-gift-box')) return
            total = total / 100
            if (cartTotal > 9900) {
                freeShippingEl.style.display = 'none'
                document.querySelector('.free-gift-box').style.display = 'block';
                return;
            }
            if (total >= 99) {
                freeShippingEl.style.display = 'none'
                document.querySelector('.free-gift-box').style.display = 'block';
            } else {
                document.querySelector('.free-gift-box').style.display = 'none';
                freeShippingEl.innerHTML = `<shipping-fee-progress class="sf-container" data-total="${(99 - total).toFixed(2)}">
                <div class="sf-text">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M3.46216 15.9773C3.46216 16.5058 3.67208 17.0126 4.04574 17.3862C4.4194 17.7599 4.92619 17.9698 5.45463 17.9698C5.98306 17.9698 6.48985 17.7599 6.86351 17.3862C7.23717 17.0126 7.44709 16.5058 7.44709 15.9773C7.44709 15.4489 7.23717 14.9421 6.86351 14.5684C6.48985 14.1948 5.98306 13.9849 5.45463 13.9849C4.92619 13.9849 4.4194 14.1948 4.04574 14.5684C3.67208 14.9421 3.46216 15.4489 3.46216 15.9773Z"
                            fill="#3A5B39" />
                        <path
                            d="M17.6723 7.29918L13.6921 5.07569V4.30738C13.6921 3.05497 12.6674 2.03027 11.415 2.03027H4.03162C2.77921 2.03027 1.75452 3.05497 1.75452 4.30738V13.4158C1.75452 14.0605 2.0261 14.6449 2.46047 15.0602C2.85263 13.7786 4.04481 12.8465 5.45482 12.8465C7.08805 12.8465 8.42898 14.0971 8.57281 15.6929H11.428C11.5718 14.0971 12.9128 12.8465 14.546 12.8465C15.956 12.8465 17.1482 13.7786 17.5403 15.0602C17.9747 14.6449 18.2463 14.0605 18.2463 13.4158V8.43295C18.3002 7.98736 18.0868 7.5307 17.6723 7.29918ZM16.5385 10.0001C16.5385 10.3132 16.2823 10.5694 15.9692 10.5694H13.6921C13.379 10.5694 13.1228 10.3132 13.1228 10.0001V7.72304C13.1228 7.40994 13.379 7.15376 13.6921 7.15376C14.0052 7.15376 14.2614 7.40994 14.2614 7.72304V9.43087H15.9692C16.2823 9.43087 16.5385 9.68704 16.5385 10.0001Z"
                            fill="#3A5B39" />
                        <path
                            d="M12.5533 15.9773C12.5533 16.5058 12.7633 17.0126 13.1369 17.3862C13.5106 17.7599 14.0174 17.9698 14.5458 17.9698C15.0742 17.9698 15.581 17.7599 15.9547 17.3862C16.3284 17.0126 16.5383 16.5058 16.5383 15.9773C16.5383 15.4489 16.3284 14.9421 15.9547 14.5684C15.581 14.1948 15.0742 13.9849 14.5458 13.9849C14.0174 13.9849 13.5106 14.1948 13.1369 14.5684C12.7633 14.9421 12.5533 15.4489 12.5533 15.9773Z"
                            fill="#3A5B39" />
                    </svg>
                    <span>
                        You're only <span>$${(99 - total).toFixed(2)}</span> away from <span>free shipping</span>!
                    </span>
                </div>
                <div class="p-progress-container ">
                    <div class="p-c-progress">
                        <div class="p-progress "></div>
                    </div>
                    <span>
                        Only $${(99 - total).toFixed(2)}
                    </span>
                </div>
            </shipping-fee-progress>`
                // Notes: You're only $${(99 - total).toFixed(2)} away from free shipping!
                freeShippingEl.style.display = 'block'
                //  el.style.display = 'block'
            }

        }

        const parseIdMatchV2 = (cart) => {
            const beds_pid_in_cart = []
            const beds_vid_in_cart = []
            const p_v_id_map = {}
            const idNumsMap_variant = cart.items.reduce((res, item) => {
                if (matchMap[item.variant_id]) res.addons[item.variant_id] = [item.variant_id]
                p_v_id_map[item.variant_id] = item.product_id;
                  if (bedIds.indexOf(item.product_id) > -1) {
                    // v_id of beds in cart
                    if (beds_pid_in_cart.indexOf(item.product_id) == -1)
                      beds_pid_in_cart.push(item.product_id);
                  }
                if (bedVariantIds.indexOf(item.variant_id) > -1) { // p_id of beds in cart 
                    if (beds_vid_in_cart.indexOf(item.variant_id) == -1) beds_vid_in_cart.push(item.variant_id)
                }
                return res;
            }, { addons: {} })
            //exclude beds pid and add on id in same product
            // 1. beds 
            let _beds_pid_in_cart = beds_pid_in_cart;
            Object.keys(idNumsMap_variant.addons).forEach((addonVariantId) => {
              let bed_p_id = p_v_id_map[addonVariantId];
              _beds_pid_in_cart = _beds_pid_in_cart.filter(
                (item) => item != bed_p_id
              );
            })
            let res_1 = judgeMatchBeds(
              _beds_pid_in_cart,
              beds_vid_in_cart,
              idNumsMap_variant,
              p_v_id_map
            );
            if (!res_1.isMatchBed)return res_1
              // 2. exclude add ons
              Object.keys(idNumsMap_variant.addons).forEach(
                (addonVariantId) => {
                  let bed_p_id = p_v_id_map[addonVariantId];
                  if (beds_pid_in_cart.find((item) => item == bed_p_id)) {
                    delete idNumsMap_variant.addons[addonVariantId];
                  }
                }
              );
            return judgeMatchBeds(
              beds_pid_in_cart,
              beds_vid_in_cart,
              idNumsMap_variant,
              p_v_id_map
            );
        }
        const judgeMatchBeds = (
          beds_pid_in_cart,
          beds_vid_in_cart,
          idNumsMap_variant,
          p_v_id_map
        ) => {
          let addons_arr = Object.keys(idNumsMap_variant.addons);
          if (!beds_vid_in_cart.length && !beds_pid_in_cart.length)
            return { isMatchBed: true };
          if (!addons_arr.length) return { isMatchBed: true };
          let add_ons = Object.keys(idNumsMap_variant.addons).find(
            (addonVariantId) => {
              let pIds_set = Array.from(
                new Set([...matchMap[addonVariantId].pIds, ...beds_pid_in_cart])
              );
              let vIds_set = Array.from(
                new Set([
                  ...(matchMap[addonVariantId].vIds ?? []),
                  ...beds_vid_in_cart,
                ])
              );
              let intersect_set =
                pIds_set.length <
                matchMap[addonVariantId].pIds.length + beds_pid_in_cart.length;
              let intersect_set_v =
                vIds_set.length <
                (matchMap[addonVariantId].vIds ?? []).length +
                  beds_vid_in_cart.length;
              return intersect_set_v || intersect_set;
            }
          );
          return {
            isMatchBed: !!add_ons,
            addons: idNumsMap_variant.addons ?? {},
          };
        };
        const handle = (cart) => {
            try {
                window.tc = cart.items;
                return parseIdMatchV2(cart)
            } catch (error) {
                console.log(error)
                return {}
            }
        }
        window.handleMatchAddonsAndBeds = (cart) => {
            try {
                cart.items = cart.items.filter((item) => item.quantity > 0);
                addonTips(handle(cart))
            } catch (error) {
                console.log(error)
            }
        }

        window.handleMatchShippingFee = (total, cartTotal) => {
            try {
                shippingFeeFn(total, cartTotal)
            } catch (error) {
                console.log(error)
            }
        }
    }
}